import React from 'react';
import { Link } from 'react-router-dom';
import { InfinityIcon, TruckIcon, LayersIcon, MailIcon, ShieldIcon } from 'lucide-react';
import { UspsBadge } from './UspsBadge';
import { PaymentLogos } from './PaymentLogos';
const promises = [{
  icon: InfinityIcon,
  title: 'Lifetime replacement on multi-packs',
  body: 'Break it. We replace it. Optional on single X1 orders. Terms apply.',
  gold: true
}, {
  icon: LayersIcon,
  title: 'Full lens system',
  body: 'Clear, Amber and Smoke in every Complete System, or add them to your build.'
}, {
  icon: TruckIcon,
  title: 'Free U.S. shipping',
  body: 'Free standard shipping on every order.'
}, {
  icon: ShieldIcon,
  title: 'Built for real work',
  body: 'Made for people who use their hands.'
}];
const columns = [{
  title: 'Shop',
  links: [{
    label: 'Build your X1 from $29.95',
    href: '/#build-your-x1'
  }, {
    label: '1 X1 Complete System for $49.95',
    href: '/#offer'
  }, {
    label: 'Buy 2, get 1 free: $99.90',
    href: '/#offer'
  }, {
    label: 'Buy 4, get 2 free: $179.90',
    href: '/#offer'
  }, {
    label: 'Business / crew pack: $699.90',
    href: '/#company'
  }]
}, {
  title: 'Product',
  links: [{
    label: 'The 3-lens system',
    href: '/#lenses'
  }, {
    label: 'Product details',
    href: '/#details'
  }, {
    label: 'Specs & answers',
    href: '/#specs'
  }, {
    label: 'How it compares',
    href: '/#why'
  }]
}, {
  title: 'Support',
  links: [{
    label: 'Track my order',
    href: '/track'
  }, {
    label: 'How to use your X1',
    href: '/guide'
  }, {
    label: 'Lifetime replacement',
    href: '/#guarantee'
  }, {
    label: 'Shipping & returns',
    href: '/#shipping'
  }, {
    label: 'Reviews',
    href: '/#reviews'
  }, {
    label: 'FAQ',
    href: '/#faq'
  }, {
    label: 'Activate your X1',
    href: '/activate'
  }, {
    label: 'Verify your GritVue',
    href: '/verify'
  }, {
    label: 'Crew Rewards',
    href: '/rewards'
  }, {
    label: 'Contact us',
    href: '/legal/contact'
  }]
}];
const legal = [{
  label: 'Privacy policy',
  to: '/legal/privacy'
}, {
  label: 'Terms of service',
  to: '/legal/terms'
}, {
  label: 'Returns & refunds',
  to: '/legal/returns'
}, {
  label: 'Shipping policy',
  to: '/legal/shipping'
}, {
  label: 'Warranty & protection terms',
  to: '/legal/guarantee'
}, {
  label: 'Legal notice & safety',
  to: '/legal/legal-notice'
}, {
  label: 'Contact us',
  to: '/legal/contact'
}];
export function SiteFooter() {
  return <footer id="support" className="scroll-mt-20 bg-ink-950" data-id="element-1231" data-mp="235wfi4104q34">
      <div className="border-y border-white/10 bg-ink-900" data-id="element-1232" data-mp="1ybsb9sj4ew5q">
        <ul className="mx-auto grid max-w-[1400px] gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-1233" data-mp="1tdqtrc1cf4wd">
          {promises.map(promise => {
          const Icon = promise.icon;
          return <li key={promise.title} className={`flex items-start gap-3 px-5 py-6 lg:px-6 ${promise.gold ? 'bg-[#1a1408]' : 'bg-ink-900'}`} data-id="element-1234" data-mp="1kdtxopcmj3ra">
                <Icon className={`mt-0.5 h-6 w-6 shrink-0 ${promise.gold ? 'text-[#f2c94c]' : 'text-grit-500'}`} aria-hidden="true" data-id="element-1235" data-mp="3r11by0sh8530" />
                <span data-id="element-1236" data-mp="4vnzayz2kulm">
                  <span className={`block font-display text-lg font-bold uppercase leading-tight tracking-wide ${promise.gold ? 'gold-text' : 'text-offwhite'}`} data-id="element-1237" data-mp="4v4i5kh8ua8n">
                    {promise.title}
                  </span>
                  <span className="mt-1 block text-[13px] text-steel-400" data-id="element-1238" data-mp="3dao37w7rgmcm">{promise.body}</span>
                </span>
              </li>;
        })}
        </ul>
      </div>

      <div className="mx-auto grid max-w-[1400px] gap-10 px-4 py-14 sm:px-6 lg:grid-cols-[1.5fr_1fr_1fr_1fr] lg:px-8 lg:py-16" data-id="element-1239" data-mp="3m4awnfohxdin">
        <div data-id="element-1240" data-mp="2pj0w6yu0m619">
          <span className="block font-display text-4xl font-extrabold uppercase leading-none tracking-tight text-offwhite" data-id="element-1241" data-mp="2tmfc7phyemep">
            Grit<span className="text-grit-500" data-id="element-1242" data-mp="2ah0uajdlj7uy">Vue</span>
            <sup className="ml-1 align-super text-[11px] text-steel-500" data-id="element-1243" data-mp="2afhbal0k2iph">™</sup>
          </span>
          <span className="mt-1.5 block text-[10px] font-semibold uppercase tracking-[0.34em] text-steel-400" data-id="element-1244" data-mp="25gml2y09drvc">
            See the job through
          </span>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-steel-400" data-id="element-1245" data-mp="2ffvi5zqf7mlx">
            GritVue X1 is illuminated work eyewear with built-in hands-free light and three interchangeable lenses.
            Designed for mechanics, builders, techs, drivers and anyone who works with their hands.
          </p>
          <div className="mt-6 border border-white/12 bg-ink-900 p-5" data-id="element-1246" data-mp="3356aqtxmaaoz">
            <h2 className="font-display text-xl font-bold uppercase tracking-wide text-offwhite" data-id="element-1247" data-mp="2y74uegrksph7">
              Support &amp; contact
            </h2>
            <p className="mt-2 text-sm text-steel-400" data-id="element-1248" data-mp="18ukmayksq8jz">
              Questions, order help or a lifetime replacement claim. A real person answers.
            </p>
            <a href="mailto:support@gritvuegear.com" className="mt-4 inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-offwhite transition-colors duration-150 ease-grit hover:text-grit-500" data-id="element-1249" data-mp="3fhs24egarhxt">
              <MailIcon className="h-4 w-4 text-grit-500" aria-hidden="true" data-id="element-1250" data-mp="3apqr0vuv7x9d" />
              support@gritvuegear.com
            </a>
            <p className="mt-2 text-xs font-semibold uppercase tracking-wide text-steel-500" data-id="element-1251" data-mp="2wp65hrxkfnc6">
              Monday to Friday · 8am to 6pm CT
            </p>
            <address className="mt-5 border-t border-white/10 pt-4 text-[13px] not-italic leading-relaxed text-steel-400" data-id="element-1252" data-mp="2ms1ixqzt5puu">
              <span className="block text-[10px] font-bold uppercase tracking-[0.22em] text-steel-500" data-id="element-1253" data-mp="2rqmjxsmvwdkc">
                U.S. fulfillment network
              </span>
              GritVue Gear ships from U.S. warehouses in Fort Worth, TX, Tampa, FL and Los Angeles, CA.
            </address>
            <div className="mt-4" data-id="element-1254" data-mp="oicdnip3zihv">
              <UspsBadge data-id="element-1255" data-mp="ojdrfuxiej3a" />
            </div>
          </div>
        </div>

        {columns.map(column => <nav key={column.title} aria-label={column.title} data-id="element-1256" data-mp="jhy94ampuqol">
            <h2 className="font-display text-lg font-bold uppercase tracking-[0.12em] text-offwhite" data-id="element-1257" data-mp="ejmwjs51e22o">
              {column.title}
            </h2>
            <ul className="mt-5 grid gap-3" data-id="element-1258" data-mp="9n6bx7x1q5uc">
              {column.links.map(link => <li key={link.label} data-id="element-1259" data-mp="178c0dyxh8li4">
                  <Link to={link.href} className="text-sm text-steel-400 transition-colors duration-150 ease-grit hover:text-grit-500" data-id="element-1260" data-mp="12aajnkniwy9t">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </nav>)}
      </div>

      <div className="border-t border-white/10" data-id="element-1261" data-mp="1q0d71nghtg23">
        <div className="mx-auto flex max-w-[1400px] flex-col gap-6 px-4 py-8 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-8" data-id="element-1262" data-mp="1l8v7n3u4bnj8">
          <nav aria-label="Legal" data-id="element-1263" data-mp="1tiu7ypnybdvx">
            <ul className="flex flex-wrap gap-x-6 gap-y-2" data-id="element-1264" data-mp="1tjluzc3hg3al">
              {legal.map(item => <li key={item.label} data-id="element-1265" data-mp="1xl73kl8zhvez">
                  <Link to={item.to} className="text-xs font-semibold uppercase tracking-wide text-steel-400 transition-colors duration-150 ease-grit hover:text-grit-500" data-id="element-1266" data-mp="22hnx5uyyd1zg">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-1267" data-mp="2gfvrdv4ltp6x">
            <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-steel-500" data-id="element-1268" data-mp="2l8ovcgs90thy">Secure checkout</p>
            <div className="mt-2" data-id="element-1269" data-mp="2q7ib6fv0cwla">
              <PaymentLogos data-id="element-1270" data-mp="2q6gotf8jkno9" />
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-1271" data-mp="2v7xnr57gu027">
        <div className="mx-auto flex max-w-[1400px] flex-col gap-3 px-4 py-6 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-8" data-id="element-1272" data-mp="2v51o9cfyz3bn">
          <p className="text-xs text-steel-500" data-id="element-1273" data-mp="3lg4qb6eub2la">© {new Date().getFullYear()} GritVue. All rights reserved.</p>
          <p className="max-w-xl text-xs leading-relaxed text-steel-500" data-id="element-1274" data-mp="3ggrvnzhq8r85">
            GritVue X1. Illuminated work glasses with built-in hands-free light and three interchangeable lenses.
          </p>
          <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-steel-400" data-id="element-1275" data-mp="3pjszftj4e68n">Light where you look</p>
        </div>
      </div>
    </footer>;
}